import React, { useContext, useEffect } from 'react';
import { AppContextProvider } from '../AppLoader';
import { Box } from '@wix/design-system';
import { dataHooks } from '../../dataHooks';
import { DialogFormContainer } from '../DialogContainer';
import { keys } from '../../translationsKeys';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { ThemedHeading, ThemedText } from '../ThemedComponents';
import { BodyContainer } from '../AuthPage/AuthPage';
import s from './PosDeviceConnectionSuccessful.scss';

interface ConnectionSuccessfulProps {}

export const PosDeviceConnectionSuccessful: React.FC<ConnectionSuccessfulProps> =
  observer(() => {
    const {
      rootStore: {
        posDeviceLoginStore,
        displayStore: { isMobile },
      },
    } = useContext(AppContextProvider);
    const { t } = useTranslation();
    useEffect(() => {
      const timeout = setTimeout(() => {
        posDeviceLoginStore.redirectToWix();
      }, 10000);

      return () => clearTimeout(timeout);
    }, []);
    return (
      <Box direction="vertical" align="center" width="100%">
        <DialogFormContainer
          dataHook={dataHooks.posDeviceLogin.container}
          formClasses={[s.posDeviceConnectionSuccessfulForm]}
          mainHeaderProps={{ showBackButton: false }}
        >
          <BodyContainer>
            <Box marginBottom={3} verticalAlign="middle">
              <ThemedHeading
                appearance={isMobile ? 'H2' : 'H1'}
                dataHook={dataHooks.posDeviceConnectionSuccessful.title}
              >
                {t(keys['posDevice.connection.successful.title'])}
              </ThemedHeading>
            </Box>
            <Box marginBottom={3} verticalAlign="middle">
              <ThemedText weight="bold" size="small">
                {t(keys['posDevice.connection.successful.content.first'])}
              </ThemedText>
            </Box>
            <Box marginBottom={3} verticalAlign="middle">
              <ThemedText size="small">
                {t(
                  keys[
                    'posDevice.connection.successful.content.second.text.third'
                  ],
                )}
              </ThemedText>
            </Box>
          </BodyContainer>
        </DialogFormContainer>
      </Box>
    );
  });
